/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconExperiencingViolence extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "ExperiencingViolenceIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><g><rect width="64" height="64" fill="none"></rect><path d="M23.32,61.16,22.82,55l-3.4,1a6.47,6.47,0,0,1-8.19-5.15L9.81,42.32,5.85,41a2.36,2.36,0,0,1-1.39-3.29l4.27-8.64c0-10.05,4.88-20.37,19.55-21.57,15.11-1.23,23.36,9.32,24.28,20.64a21.54,21.54,0,0,1-3.38,13.07,19.2,19.2,0,0,0-2.59,11.57l.52,6.4Z" fill="#ffcc80"></path><path d="M16.26,30.66s-2.87,3.4-2.87,5.33a2.87,2.87,0,0,0,5.74,0C19.13,34.06,16.26,30.66,16.26,30.66Z" fill="#42a5f5"></path><path d="M27.07,34.55c-1.74-.45-3.59,1.22-3.81-.32-1.91-13-16.52-13.47-16.52-13.47s3.82-16,19-17.61c13.11-1.4,27.06,0,34,44.41L41.72,55.29,36.86,40s4.63-8.8-2.08-12.74S27.07,34.55,27.07,34.55Z" fill="#90695b"></path></g></svg>
    `;
}
